import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { xor } from 'lodash';
import { RATINGS } from '../../../../lib/schema.js';
import RatingLabel from '../../../RatingLabel.jsx';

StakeholderImpactsFilter.defaultProps = {
  selectedStakeholderImpacts: [],
};

function StakeholderImpactsFilter({
  selectedStakeholderImpacts,
  navigateAction,
}) {
  const selectedCount = selectedStakeholderImpacts.length;
  const handleSelect = useCallback(
    (stakeholderImpact) =>
      navigateAction({
        stakeholderImpacts: stakeholderImpact
          ? xor(selectedStakeholderImpacts, [stakeholderImpact])
          : [],
      }),
    [selectedStakeholderImpacts]
  );

  const renderMenuItem = useCallback(
    (stakeholderImpact) => (
      <React.Fragment key={stakeholderImpact}>
        <MenuItem
          active={selectedStakeholderImpacts.includes(stakeholderImpact)}
          eventKey={stakeholderImpact}
          onSelect={handleSelect}
        >
          <RatingLabel rating={stakeholderImpact} reverse />
        </MenuItem>
      </React.Fragment>
    ),
    [selectedStakeholderImpacts]
  );
  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        Stakeholder Predicted Impact
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="stakeholder-impact-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>

          <MenuItem divider />
          {RATINGS.HIGH_MEDIUM_LOW.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default StakeholderImpactsFilter;
